const waitForImage = async (image) => {
  if (!image.complete) {
    await new Promise((resolve, reject) => {
      image.addEventListener('load', resolve, { once: true });
      image.addEventListener('error', () => reject(new Error(`Unable to load print image: ${image.src}`)), { once: true });
    });
  }

  if (!image.naturalWidth) {
    throw new Error(`Unable to load print image: ${image.src}`);
  }

  if (typeof image.decode === 'function') {
    await image.decode();
  }
};

export const printWhenReady = async (printWindow) => {
  try {
    await Promise.all(Array.from(printWindow.document.images, waitForImage));
  } catch (error) {
    console.error('Unable to print because an image did not load:', error);
    alert('The stamp or logo could not be loaded. Please try printing again.');
    printWindow.close();
    return false;
  }

  printWindow.focus();
  printWindow.print();
  return true;
};
